<!-- desktop Footer -->
@if (!isMobile) {
  <footer class="flex h-auto footer-background mt-8 text-white">
  <div class="w-full mx-auto max-w-lg md:w-full md:max-w-5xl md:grid md:grid-cols-5 grid grid-cols-2
   gap-1 pt-14 p-5 pb-20 md:pb-5">
      <div class="pb-5 -ml-3">
        <a href="https://energyplus.at">
          <div class="logo"></div>
        </a>
      </div>
      <div class="pb-5">
        <span style="font-family:'asap-medium', sans-serif">Energy+ Solutions GmbH</span><br>
        Linzerberg 5<br>
        A-4209 Engerwitzdorf<br>
      </div>
      <div class="pb-5">
        <a href="tel:00436765061384">+43 676 506 13 84</a><br>
        <a href="mailto:office@energyplus.at">office&#64;energyplus.at</a><br>
        <a target="_blank" href="https://energyplus.at">www.energyplus.at</a><br>
      </div>
      <div class="pb-5">
        <a target="_blank" href="https://energyplus.at/privatkunden-blog/">News</a><br>
        <a target="_blank" href="https://energyplus.at/referenzprojekte/">Über uns | Energy+ Brain</a><br>
        <a target="_blank" href="https://energyplus.at/agb">AGB</a><br>
      </div>
      <div class="pb-5">
        <a target="_blank" href="https://energyplus.at/privatkunden-kontakt/">Support | Kontakt | FAQs</a><br>
        <a target="_blank" href="https://energyplus.at/impressum/">Impressum </a> |
        <a target="_blank" href="https://energyplus.at/datenschutz/"> Datenschutz</a><br>
        <a target="_blank" href="https://www.linkedin.com/company/energy-e-u/">
          <div class="footer-logos linkedin-logo"></div>
        </a>
        <a target="_blank" href="https://www.instagram.com/energyplus.at?utm_source=qr&igshid=NGExMmI2YTkyZg%3D%3D">
          <div class="footer-logos insta-logo"></div>
        </a>
        <a target="_blank" href="https://www.facebook.com/profile.php?id=61552346361556">
          <div class="footer-logos facebook-logo"></div>
        </a>
        <a target="_blank" href="https://www.youtube.com/@EnergyplusSolutionsGmbH">
          <div class="footer-logos youtube-logo"></div>
        </a>
        <br>
        </div>
      </div>
    </footer>
  }


  <!-- mobile Footer -->
  @if (isMobile) {
    <footer class="flex h-auto mt-2 ">
      <div class="w-full mx-auto max-w-lg md:w-full md:max-w-5xl p-5 pb-13">
      </div>
    </footer>
  }
